import Vue from 'vue';
import VueRouter from 'vue-router';
import { requireAuth } from '@/router/authentication.js';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		meta: { requireAuth: true },
		component: () => import('@/views/Index'),
		children: [
			{
				path: '/dashboard',
				name: 'Dashboard',
				component: () => import('@/views/Client/partials/Dashboard.vue'),
			},
			{
				path: '/monitoring',
				name: 'Monitoring',
				component: () => import('@/views/Client/components/MonitoringComponent'),
			},
			{
				path: '/patientdetails/:id(\\d+)',
				name: 'Patient Details',
				component: () => import('@/views/Client/components/PatientDetails'),
			},
			{
				path: '/devicemeasurements/:id(\\d+)', // Expr. matches only numbers!',
				name: 'Device Measurements',
				component: () => import('@/views/Client/partials/DeviceMeasurements'),
			},
			{
				path: '/organizations',
				name: 'Organization',
				component: () => import('@/views/Admin/Organizations.vue'),
			},
			{
				path: '/admins',
				name: 'Admins',
				component: () => import('@/views/Admin/Admins'),
			},
			{
				path: '/offices',
				name: 'Office',
				component: () => import('@/views/Admin/Offices.vue'),
			},
			{
				path: '/patients',
				name: 'Patients',
				component: () => import('@/views/Client/partials/Patients'),
			},
			{
				path: '/billings',
				name: 'Billings',
				component: () => import('@/views/Client/partials/Billings'),
			},
			{
				path: '/medicalteam',
				name: 'Medical Team',
				component: () => import('@/views/Client/partials/MedicalTeam'),
			},
			{
				path: '/medicalstaff',
				name: 'Medical Staff',
				component: () => import('@/views/Client/partials/MedicalStaff'),
			},
			{
				path: '/support',
				name: 'Support',
				component: () => import('@/views/Client/partials/Support'),
			},
			{
				path: '/Verifier',
				name: 'Verifier',
				component: () => import('@/views/Admin/Verifiers.vue'),
			},
			{
				path: '/SaReports',
				name: 'SA_Reports',
				component: () => import('@/views/Admin/SaReports'),
			},
			{
				path: '/OaReports',
				name: 'OA_Reports',
				component: () => import('@/views/Admin/OaReports'),
			},
			{
				path: '/wellnessassessments',
				name: 'Assessments',
				component: () => import('@/views/Client/partials/Assessments.vue'),
			},
			{
				path: '/invoices',
				name: 'Invoices',
				component: () => import('@/views/Client/partials/Invoices'),
			},
			{
				path: '/dailyreports',
				name: 'Daily Reports',
				component: () => import('@/views/Client/components/DailyReports.vue'),
			},
			{
				path: '/monthlyreview',
				name: 'Monthly Review',
				component: () => import('@/views/Client/components/MonthlyReview.vue'),
			},
			{
				path: '/billingsettings',
				name: 'Billing Settings',
				component: () => import('@/views/Client/partials/BillingsSettingsTemplate.vue'),
			},
			{
				path: '/UserBillingSettings',
				name: 'User Billing Settings',
				component: () => import('@/views/Client/partials/UserBillingsSettings.vue'),
			},
			{
				path: '/medicalNotesCategory',
				name: 'Medical Note Category',
				component: () => import('@/views/Client/partials/MedicalNotesCategory.vue'),
			},
			{
				path: '/emptyComponent',
				name: 'Empty Component',
				component: () => import('@/views/Client/partials/EmptyComponent.vue'),
			},
			{
				path: '/dashboardFacility',
				name: 'Facility Dashboard',
				component: () => import('@/views/Client/partials/DashboardFacility.vue'),
			},
			{
				path: '/schedules',
				name: 'Schedules',
				component: () => import('@/views/Client/partials/Schedules.vue'),
			},
			{
				path: '/schedules-reports',
				name: 'Schedules Reports',
				component: () => import('@/views/Client/partials/SchedulesReports.vue'),
			},
			{
				path: '/dashboardAdmin',
				name: 'Admin Dashboard',
				component: () => import('@/views/Client/partials/DashboardOrgAdmin.vue'),
			},
			{
				path: '/dashboardsystemadmin',
				name: 'System Admin Dashboard',
				component: () => import('@/views/Client/partials/DashboardSystemAdmin.vue'),
			},
			{
				path: '/partnerBillingReports',
				name: 'Partner Billing Reports',
				component: () => import('@/views/Client/partials/PartnerBillingReports.vue'),
			},
			{
				path: '/residentMapping',
				name: 'Mapping Patients',
				component: () => import('@/views/Client/partials/ResidentMapping.vue'),
			},
			{
				path: '/organizationMapping',
				name: 'Organization mapping',
				component: () => import('@/views/Client/partials/OrganizationMapping.vue'),
			},
			{
				path: '/locationMapping',
				name: 'Location mapping',
				component: () => import('@/views/Client/partials/LocationMapping.vue'),
			},
			{
				path: '/medicalStaffMapping',
				name: 'Mapping Medical Staff',
				component: () => import('@/views/Client/partials/MedicalStaffMapping.vue'),
			},
			{
				path: '/residentMappingPcc',
				name: 'PointClickCare Patient Mapping',
				component: () => import('@/views/Client/partials/ResidentMappingPcc.vue'),
			},
			{
				path: '/medicalStaffMappingPcc',
				name: 'PointClickCare Mapping Medical Staff',
				component: () => import('@/views/Client/partials/MedicalStaffMappingPcc.vue'),
			},
			{
				path: '/organizationMappingPcc',
				name: 'PointClickCare Organization Mapping',
				component: () => import('@/views/Client/partials/OrganizationMappingPcc.vue'),
			},
			{
				path: '/logs',
				name: 'Logs',
				component: () => import('@/views/Client/components/Logs.vue'),
			},
			{
				path: '/licenses',
				name: 'Licenses',
				component: () => import('@/views/Client/components/Licenses.vue'),
			},
			{
				path: '/tablets',
				name: 'Tablets',
				component: () => import('@/views/Client/components/ViewTablets.vue'),
			},
			{
				path: '/releaseNotesAndManuals',
				name: 'Release Notes and Manuals',
				component: () => import('@/views/Client/components/ReleaseNotesAndManuals.vue'),
			},
			{
				path: '/terraPatientIntegration',
				name: 'Terra Patient Integration',
				component: () => import('@/views/Client/components/TerraPatientIntegration.vue'),
			},
			{
				path: '/pccLocationMapping',
				name: 'PointClickCare Location Mapping',
				component: () => import('@/views/Client/components/PCCLocationMapping.vue'),
			},
			{
				path: '/itemCatalog',
				name: 'Item Catalog',
				component: () => import('@/views/Client/components/InventoryItemCatalog.vue'),
			},
			{
				path: '/consumableCatalog',
				name: 'Consumable Catalog',
				component: () => import('@/views/Client/components/InventoryConsumableCatalog.vue'),
			},
			{
				path: '/inventoryItems',
				name: 'Inventory Items',
				component: () => import('@/views/Client/components/InventoryItems.vue'),
			},
			{
				path: '/inventoryConsumables',
				name: 'Inventory Consumables',
				component: () => import('@/views/Client/components/InventoryConsumable.vue'),
			},
			{
				path: '/device-template',
				name: 'Device Template',
				component: () => import('@/views/Client/components/DeviceTemplate.vue'),
			},
			{
				path: '/auditReport',
				name: 'Audit Report',
				component: () => import('@/views/Client/components/AuditComponent.vue'),
			},
		],
	},
	{
		path: '/auth',
		redirect: '/auth/login',
		name: 'Login',
		component: () => import('@/views/authentication/Login'),
		children: [
			{
				path: '/auth/login',
				component: () => import('@/views/authentication/Login'),
			},
		],
	},
	{
		path: '/api/user/validatetoken',
		name: 'Confirm Validation',
		component: () => import('@/views/authentication/ResetPassword'),
	},
	{
		path: '/auth/successfully',
		name: 'SuccessfullyChangedPassword',
		component: () => import('@/views/authentication/SuccessfullyChangedPassword'),
	},
	{
		path: '/videoRoom/:id(\\d+)/:userId(\\d+)/:appointmentId(\\d+)',
		meta: { reqviewsreAuth: true },
		name: 'VideoRoom',
		component: () => import('@/views/Client/partials/VideoRoom'),
	},
	{
		path: '/accountdeletionrequest',
		name: 'Deletion Request',
		component: () => import('@/views/authentication/DeleteAccountForm'),
	},
	{
		path: '/profileremovalinfo',
		name: 'Profile Removal Info',
		component: () => import('@/views/authentication/ProfileRemovalInfo'),
	},
	{
		path: '/auth/forgetpassword',
		name: 'Forget Password',
		component: () => import('@/views/authentication/ForgetPassword'),
	},
	{
		path: '/measurements',
		name: 'HTML Rendering',
		component: () => import('@/views/Client/partials/no-auth/RenderData'),
	},
	{
		path: '/measurements/:hubIdentifier',
		name: 'Patient Report',
		component: () => import('@/views/Client/partials/no-auth/RenderDataForPatient'),
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/auth/login',
	},
];
const router = new VueRouter({
	mode: 'history',
	// base: process.env.BASE_URL,
	routes: routes,
});

router.beforeEach(requireAuth);
export default router;
